import { AuiIf } from '@assistant-ui/react';

/**
 * Status bar shown in place of the composer for read-only conversations.
 * Reflects a live watched run so viewers can tell the agent is still working.
 */
export function AgentWorkbenchReadOnlyBar() {
	return (
		<div className='shrink-0 border-t border-gray-a6 bg-gray-2 px-4 py-3 text-center text-sm text-gray-11'>
			<AuiIf condition={(s) => s.thread.isRunning}>
				<span>Agent is responding…</span>
			</AuiIf>
			<AuiIf condition={(s) => !s.thread.isRunning}>
				<span>Read-only conversation</span>
			</AuiIf>
		</div>
	);
}
